import { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
import //   getActiveRequest,
//   getOrdersWorks,
//   request,
"../../../store/modules/RequestStore";
import {
  Body,
  Etiqueta,
  Id,
  Photo,
  Solicitud,
  SolicitudInfo,
  Span,
  Tecnico,
  Title,
} from "./ListElements";
import { SinAsignar } from "../../../components/svg/SinAsignar";
import { useTranslation } from "react-i18next";
import TranslatableText from "../../Multilanguage/TranslatableText";

export const Request = (props) => {
  const { setCurrentRequestID, rq, IconVia } = props;
  const { t } = useTranslation();
  //   const dispatch = useDispatch();
  //   const requestState = useSelector(request);

  useEffect(() => {
    // dispatch(getActiveRequest(rq.requestID));
  }, []);

  const getSubjectContent = (subject) => {
    const reqMatch = subject.match(/^\[REQ\d*\]\s*(.*)$/);
    const incMatch = subject.match(/^\[INC\d*\]\s*(.*)$/);
    if (reqMatch) {
      return reqMatch[1];
    } else if (incMatch) {
      return incMatch[1];
    }
    return subject;
  };

  const getSubjectPrefix = (subject) => {
    const reqMatch = subject.match(/^\[REQ(\d*)\]/);
    const incMatch = subject.match(/^\[INC(\d*)\]/);
    if (reqMatch) {
      return `REQ${reqMatch[1] || ''}-`;
    } else if (incMatch) {
      return `INC${incMatch[1] || ''}-`;
    }
    return '';
  };

  const subjectContent = getSubjectContent(rq.subject);
  const subjectPrefix = getSubjectPrefix(rq.subject);

  return (
    <Solicitud
      onClick={() => setCurrentRequestID(rq.requestID)}
      to={`/request/${rq.requestID}`}
    >
      <SolicitudInfo>
        <Id>
          {rq.subject.slice(1, 4) === "REQ"
            ? `${rq.subject.slice(1, 4)}-`
            : rq.subject.slice(1, 4) === "INC"
            ? `${rq.subject.slice(1, 4)}-`
            : ``}
          {rq.requestID}
          {/* {subjectPrefix}{rq.requestID} */}
        </Id>
        <Title>
          {subjectContent.length < 35 ? (
            <TranslatableText text={subjectContent} />
          ) : (
            <>
              <TranslatableText text={subjectContent.slice(0, 32)} />
              {" "}
              {"..."}
            </>
          )}
        </Title>
        <Tecnico>
          {rq.statusName === "Sin Asignar" ? (
            <Photo>
              <SinAsignar />
            </Photo>
          ) : rq.TechnicianImg !== "" ? (
            <Photo>
              <img
                className="w-full h-full rounded-full"
                src={rq.TechnicianImg}
                alt="technician name"
              />
            </Photo>
          ) : (
            <Photo bg>
              {rq.TechnicianName && rq.TechnicianName.split(" ")[0].slice(0, 1)}
              {rq.TechnicianName && rq.TechnicianName.split(" ")[1].slice(0, 1)}
            </Photo>
          )}

          <div>
            <Body>
              {rq.TechnicianName ? (
                <p className="text-xs md:text-sm">
                  {t("requestAll.assigned")} <Span>{rq.TechnicianName}</Span>
                </p>
              ) : (
                <p className="text-sm md:text-md">
                  {t("requestAll.noAssigned")}
                </p>
              )}
            </Body>
            <Body>
              <p className="flex gap-1">
                <span className="flex items-center justify-center">
                  {rq.viaName ? <IconVia via={rq.viaName} /> : ""}
                </span>
                {t("requestAll.on")} {rq.receptionDate}
              </p>
            </Body>
          </div>
        </Tecnico>
      </SolicitudInfo>
      <div className="flex flex-col items-end justify-center">
        <Etiqueta>
          <TranslatableText text={rq.statusName} />
        </Etiqueta>
      </div>
    </Solicitud>
  );
};
